import { WEB_SERVICES } from '../../../../bitSagas/webServices';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from '../../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {
      BUSINESS_ERRORS: {
        UNAVAILABLE_PRODUCT: errorToPrint.UNAVAILABLE_PRODUCT,
        ALREADY_HIRED_EQUIPMENT: errorToPrint.ALREADY_HIRED_EQUIPMENT,
        UNAVAILABLE_OR_ALREADY_HIRED: errorToPrint.UNAVAILABLE_OR_ALREADY_HIRED,
      },
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ_AFTER_SALE]: {
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT]: errorToPrint.UNAVAILABLE_PRODUCT,
          [WEBSERVICE_ERRORS.WITHOUT_DEPENDENT_OFFER]: errorToPrint.UNAVAILABLE_PRODUCT,
          [WEBSERVICE_ERRORS.OFFER_WITH_SOME_DEPENDENCIES]: errorToPrint.UNAVAILABLE_PRODUCT,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ_AFTER_SALE]: {
        },
      },
    },
    [`user_${USER_TYPE.OPEN}`]: {

    },
  }

  return handledErrors;
}
